import styles from './HeaderDropdown.module.scss';
import type { HeaderDropdownProps } from './HeaderDropdown.types.ts';
import { HeaderDropdownDesktop } from './HeaderDropdownDesktop/HeaderDropdownDesktop';
import { HeaderDropdownMobile } from './HeaderDropdownMobile/HeaderDropdownMobile';

export function HeaderDropdown(props: HeaderDropdownProps) {
  return (
    <>
      <HeaderDropdownDesktop {...props} className={styles.dropdownDesk} />
      <HeaderDropdownMobile {...props} className={styles.dropdownMobile} />
    </>
  );
}
